import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { mainRoutes } from './routes';
import { mainSubRoutes } from './subRoutes';
import NavigationWrapper from '../components/NavigationWrapper';
import NodesLayout from 'layouts/NodesLayout/NodesLayout';

// ----LAZY ROUTES----
const renderSubRoutes = mainSubRoutes.map(routeConfig => (
  <Route
    key={`claro-sub-route-${routeConfig.path}`}
    path={routeConfig.path}
    element={routeConfig.element}
  />
));

const renderRoutes = mainRoutes.map(routeConfig => (
  <Route
    key={`claro-route-${routeConfig.path}`}
    path={routeConfig.path}
    element={routeConfig.element}
  />
));

export const Navigation = () => (
  <Routes>
    {renderRoutes}
    <Route
      path="/"
      element={
        <NavigationWrapper>
          <NodesLayout />
        </NavigationWrapper>
      }
    >
      {renderSubRoutes}
    </Route>
  </Routes>
);
